<form
  class="edit-form"
  *ngIf="editForm"
  [formGroup]="editForm"
  (submit)="onSubmit()"
>
  <mat-form-field>
    <mat-label>{{
      "repository.siteGroups.edit.name.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="name" />
    <mat-error>{{
      "repository.siteGroups.edit.name.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <app-multi-select-list
    formControlName="sites"
    [allItems]="sites"
    label="repository.siteGroups.edit.sites.label"
    errorMsg="repository.siteGroups.edit.sites.errorMessage"
    [title]="'repository.siteGroups.edit.sites.title' | translate"
  >
  </app-multi-select-list>

  <mat-checkbox formControlName="allowOtherAddress">{{
    "repository.siteGroups.edit.allowOtherAddress.label" | translate
  }}</mat-checkbox>

  <app-validate-and-cancel
    (submitEvent)="endForm($event)"
    [editForm]="editForm"
    [disabling]="editForm.invalid"
  ></app-validate-and-cancel>
</form>
